import { useEffect } from "react";
import { useLocation } from "react-router";
import { getSeoForPath } from "../seo";

const setMetaTag = (attribute: "name" | "property", key: string, content?: string) => {
  const selector = `meta[${attribute}="${key}"]`;
  const existing = document.head.querySelector(selector);

  if (!content) {
    existing?.remove();
    return;
  }

  if (existing) {
    existing.setAttribute("content", content);
    return;
  }

  const meta = document.createElement("meta");
  meta.setAttribute(attribute, key);
  meta.setAttribute("content", content);
  document.head.appendChild(meta);
};

export const Seo = () => {
  const location = useLocation();

  useEffect(() => {
    const seo = getSeoForPath(location.pathname);

    document.title = seo.title;
    setMetaTag("name", "description", seo.description);
    setMetaTag("name", "keywords", seo.keywords);
    setMetaTag("name", "robots", seo.robots);
    setMetaTag("name", "googlebot", seo.googlebot);
    setMetaTag("property", "og:title", seo.title);
    setMetaTag("property", "og:description", seo.description);
    setMetaTag("name", "twitter:title", seo.title);
    setMetaTag("name", "twitter:description", seo.description);
  }, [location.pathname]);

  return null;
};
